/** Subdomínios que nunca podem ser usados por restaurantes. */
export const RESERVED_SLUGS = new Set([
  'www', 'api', 'app', 'apps', 'dev', 'admin', 'administrador', 'painel', 'dashboard', 'root',
  'mail', 'email', 'smtp', 'imap', 'pop', 'webmail', 'ftp', 'sftp', 'ssh', 'vpn', 'ns', 'ns1', 'ns2',
  'static', 'assets', 'cdn', 'media', 'img', 'images', 'uploads', 'files', 'storage',
  'status', 'health', 'monitor', 'metrics', 'logs', 'print', 'printer', 'impressao', 'agent',
  'garlic', 'garlicfood', 'suporte', 'support', 'help', 'ajuda', 'docs', 'blog', 'loja', 'store',
  'pay', 'pagamento', 'pagamentos', 'payments', 'checkout', 'webhook', 'webhooks', 'oauth', 'auth',
  'login', 'logout', 'signup', 'cadastro', 'conta', 'account', 'billing', 'test', 'teste', 'staging',
  'sandbox', 'demo', 'beta', 'localhost', 'cpanel', 'whm', 'autodiscover', 'autoconfig',
]);

export const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{1,38}[a-z0-9])$/;

export type SlugProblem = 'format' | 'reserved' | 'double-hyphen';

export function checkSlugFormat(slug: string): SlugProblem | null {
  if (!SLUG_PATTERN.test(slug)) return 'format';
  if (slug.includes('--')) return 'double-hyphen';
  if (RESERVED_SLUGS.has(slug)) return 'reserved';
  return null;
}

/** Sugere um slug a partir do nome comercial ("Bistrô do João" -> "bistro-do-joao"). */
export function slugify(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/&/g, ' e ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-')
    .slice(0, 40)
    .replace(/-+$/, '');
}

export const SLUG_PROBLEM_MESSAGES: Record<SlugProblem, string> = {
  format: 'Use de 3 a 40 caracteres: letras minúsculas, números e hífen (sem começar ou terminar com hífen).',
  'double-hyphen': 'Não use dois hífens seguidos.',
  reserved: 'Este endereço é reservado pelo sistema.',
};
